function SelectBox(selector){
	if(!selector){
		selector = '.select';
	}
	const selects = document.querySelectorAll(selector);
	const triggerChange = new Event('change');

	const gsPopup = document.createElement("DIV");
	gsPopup.id = "p" + (Math.random() * 0xffffffffffff * 100000000000).toString(16);
	gsPopup.className = "gs-popup";
	gsPopup.tabIndex = 0;

	selects.forEach(function (select) {
		const optionsRef = select.querySelector(".options");
		const options = optionsRef.querySelectorAll("button");
		const label = select.querySelector("label");
		const labelText = label.querySelector("span");
		const input = select.querySelector('input');

		gsPopup.addEventListener('click', () => CloseAll(select, gsPopup, optionsRef, labelText, input, options));
		if (select.dataset.labelWithValue === 'true') {
			if(input.value !== ''){
				const button = [...options].find(option => option.value == input.value);
				// labelText.innerText = select.dataset.prompt + ": " + button.innerText;
				if(button.value){
					labelText.innerText = button.innerText;
					select.classList.add('selected');
				}else{
					labelText.innerText = select.dataset.prompt;
				}
			}else{
				labelText.innerText = select.dataset.prompt;
			}
		}else{
			if(input.value !== ''){
				const button = [...options].find(option => option.value == input.value);
				// labelText.innerText = select.dataset.prompt + ": " + button.innerText;
				if(button.value){
					labelText.innerText = button.innerText;
					select.classList.add('selected');
				}else{
					labelText.innerText = 'Seçiniz';
				}
			}else{
				labelText.innerText = 'Seçiniz'
			}
		}

		label.addEventListener("mouseup", CloseSelectElement);

		function CloseSelectElement() {
			if(select.classList.contains('open')){
				CloseAll(select, gsPopup, optionsRef, labelText, input, options);
			}else{
				select.classList.add("open");
				select.classList.remove('selected');
				labelText.innerText = select.dataset.prompt;

				const optionsRect = optionsRef.getBoundingClientRect();
				const bodyRect = document.body.getBoundingClientRect();

				if(optionsRect.right > bodyRect.right){
					optionsRef.style.left = 'unset';
					optionsRef.style.right = 0;
				}
				optionsRef.style.maxWidth = `${select.parentElement.clientWidth}px`;
				select.append(gsPopup);
			}
			if (!select.eventAttached) {
				const scev = CloseSelect.bind(select);
				document.addEventListener("mouseup", scev);
				select.eventAttached = true;
			}
		}

		function CloseSelect(event, a) {
			if (!HasParent(event.target, this)) {
				this.classList.remove("open");
				// CloseSelectElement();
			}
		}

		options.forEach(function (option) {
			option.addEventListener("mouseup", function (ev) {
				let selectedOptionText = "";
				if (option.dataset.reset) {
					selectedOptionText = select.dataset.prompt;
					input.value='';
					select.classList.remove('selected');
				} else {
					selectedOptionText = option.innerText;
					if (select.dataset.labelWithValue === 'true') {
						selectedOptionText =
						select.dataset.prompt + ": " + selectedOptionText;
					}
					input.value=option.value;
					select.classList.add('selected');
				}
				input.dispatchEvent(triggerChange);
				labelText.innerText = selectedOptionText;
				CloseAll(select, gsPopup, optionsRef, labelText, input, options);
			});
		});
	});
}

function CloseAll(select, gsPopup, optionsRef, labelText, input, options){
	if(select.classList.contains('open')){
		optionsRef.style.left = '';
		optionsRef.style.right = '';
		document.body.classList.remove('has-popup');
		gsPopup.remove();
		select.classList.remove("open");
		if (select.dataset.labelWithValue === 'true') {
			if(input.value !== ''){
				const button = [...options].find(option => option.value == input.value);
				if(button.value){
					labelText.innerText = button.innerText;
					select.classList.add('selected');
				}else{
					labelText.innerText = select.dataset.prompt;
				}
			}
		}else{
			const button = [...options].find(option => option.value == input.value);
			if(button.value){
				labelText.innerText = button.innerText;
				select.classList.add('selected');
			}else{
				labelText.innerText = 'Seçiniz';
			}
		}
	}
}



function HasParent(el, target) {
	let element = el;
	while (element.tagName !== "BODY") {
		if (element === target) {
			return true;
		}
		element = element.parentElement;
	}
	return false;
}

export default SelectBox;
